/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 16,
    height: 16,
    viewBox: '0 0 48.22 55',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M2.49 37c1.82-3.45 5.17-5.84 11.19-7.55a3.72 3.72 0 0 1 1-.14 7.22 7.22 0 0 1 3.77 1.5 10 10 0 0 0 5.64 2 10.57 10.57 0 0 0 5.71-2 7.66 7.66 0 0 1 3.87-1.49 3.85 3.85 0 0 1 1.09.16c11 3.23 12.94 8.71 12.94 19 0 1.41-1 2.91-8.13 4.38A80.09 80.09 0 0 1 24.3 54.5h-.15A80.52 80.52 0 0 1 8.72 53C1.5 51.51.5 50 .5 48.6v-2.25M24.11.5A10.12 10.12 0 0 0 14 10.62v7.87a10.12 10.12 0 0 0 20.24 0v-7.87A10.12 10.12 0 0 0 24.11.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/user.js